/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 20/01/2021
 */
import * as SessionUtils from './../../../core/session_utils.js'

const generateInvoiceOrderRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        id_tramite_carrito: 0,
        datoFiscal: 0,
    }
}

export default generateInvoiceOrderRequest;